import { propertyIdSchema } from "@estate-platform/domain/ids";
import { createFileRoute, getRouteApi } from "@tanstack/react-router";

import { useViewer } from "../data/hooks.ts";
import { loadProperty } from "../properties/loaders.ts";
import { PropertiesPending } from "../properties/pending.tsx";
import { PropertyPage } from "../properties/property-page.tsx";
import { parameterOrNotFound } from "../shell/route-parameters.ts";
import { propertyTabSchema } from "../shell/search.ts";
import { NoAccessPage } from "../shell/status-pages.tsx";

import type { ReactElement } from "react";

const route = getRouteApi("/_app/properties/$id/{-$tab}");

const Page = (): ReactElement => {
  const viewer = useViewer();
  const { id, tab } = route.useParams();
  return viewer === null ? (
    <NoAccessPage />
  ) : (
    <PropertyPage viewer={viewer} propertyId={id} tab={tab ?? "overview"} />
  );
};

export const Route = createFileRoute("/_app/properties/$id/{-$tab}")({
  params: {
    parse: ({ id, tab }) => ({
      id: parameterOrNotFound(propertyIdSchema, id),
      tab: parameterOrNotFound(propertyTabSchema.exclude(["overview"]).optional(), tab),
    }),
    stringify: ({ id, tab }) => ({ id, tab }),
  },
  staticData: { hasHero: true },
  loader: async ({ context, params }) =>
    loadProperty(context.data, params.id, { isOverview: params.tab === undefined }),
  pendingComponent: () => <PropertiesPending kind="detail" />,
  component: Page,
});
